export default function SystemMessage({props}){
    return (
        <div>
            
        </div>
    )
}